// import ReactPlayer from 'react-player'
import Image from "next/image";

// import Swiper core and required modules
import { Autoplay, Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';


// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';

export default () => {
    return (
        <section className="bg-black h-full relative overflow-hidden rounded-xl">

            <Swiper
                modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
                // spaceBetween={50}
                slidesPerView={1}
                // centeredSlides={true}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                // autoplay={false}
                loop={true}
                navigation={true}
                // pagination={{ clickable: true }}
                // scrollbar={{ draggable: true }}
                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log('slide change')}
                className={"swiper-slider-1"}
                // navigation={{
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev',
                // }}
            >
                <SwiperSlide>
                    <div className="
                        bg-[url('/assets/img/IMG_1091.jpg')] bg-cover bg-center bg-no-repeat
                        relative overflow-hidden fluid-video-wrap sm:min-h-[400px] min-h-[250px] pt-16 lg:pt-0">
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="
                        bg-[url('/assets/img/IMG_1098.jpg')] bg-cover bg-center bg-no-repeat
                        relative overflow-hidden fluid-video-wrap sm:min-h-[400px] min-h-[250px] pt-16 lg:pt-0">
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="
                        bg-[url('/assets/img/IMG_1122.jpg')] bg-cover bg-center bg-no-repeat
                        relative overflow-hidden fluid-video-wrap sm:min-h-[400px] min-h-[250px] pt-16 lg:pt-0">
                    </div>
                </SwiperSlide>       
            </Swiper>



        </section>

    );
};